import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';

const WHATSAPP_NUMBER = '551151250926';
const LOGO_URL = '/images/logo.png';

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6 bg-transparent">
              <img 
                src={LOGO_URL} 
                alt="Ematech Industrial" 
                className="h-10 w-auto object-contain bg-transparent"
                style={{ background: 'transparent' }}
              />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Soluções em revestimentos industriais, tintas epóxi e poliuretano com fabricação própria. +20 anos de experiência no mercado.
            </p>
            <p className="text-slate-500 text-xs">
              CNPJ: 55.122.697/0001-65
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-bold text-lg uppercase tracking-wide mb-6">
              Links Rápidos
            </h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="/#servicos"
                  className="text-slate-400 hover:text-amber-400 transition-colors text-sm"
                >
                  Serviços
                </a>
              </li>
              <li>
                <a
                  href="/#produtos"
                  className="text-slate-400 hover:text-amber-400 transition-colors text-sm"
                >
                  Produtos
                </a>
              </li>
              <li>
                <Link
                  to="/conheca"
                  className="text-slate-400 hover:text-amber-400 transition-colors text-sm"
                >
                  Conheça a Ematech
                </Link>
              </li>
              <li>
                <Link
                  to="/produtos"
                  className="text-slate-400 hover:text-amber-400 transition-colors text-sm"
                >
                  Loja Virtual
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading font-bold text-lg uppercase tracking-wide mb-6">
              Contato
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-slate-300 text-sm">(11) 5125-0926</p>
                  <p className="text-slate-500 text-xs">WhatsApp</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-slate-300 text-sm">contato@ematechindustrial.com.br</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-slate-300 text-sm">Embu Guaçu, SP</p>
                  <p className="text-slate-500 text-xs">Atendemos todo o Brasil</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="font-heading font-bold text-lg uppercase tracking-wide mb-6">
              Redes Sociais
            </h3>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/ematech.industrial/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-lg bg-slate-800 hover:bg-amber-500 hover:text-slate-900 flex items-center justify-center transition-colors duration-200"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61582983150555"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                className="w-10 h-10 rounded-lg bg-slate-800 hover:bg-amber-500 hover:text-slate-900 flex items-center justify-center transition-colors duration-200"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href={`https://wa.me/${WHATSAPP_NUMBER}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="w-10 h-10 rounded-lg bg-slate-800 hover:bg-amber-500 hover:text-slate-900 flex items-center justify-center transition-colors duration-200"
                aria-label="WhatsApp"
              >
                <Phone className="w-5 h-5" />
              </a>
            </div>
            <div className="mt-8">
              <a
                href="https://ematech6.lojavirtualnuvem.com.br/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-shop-link"
                className="inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 text-sm font-medium transition-colors"
              >
                Acessar Loja Virtual
                <span aria-hidden="true">→</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Revestimentos e Adesivos Ematech. Todos os direitos reservados.
            </p>
            <div className="flex gap-6">
              <a
                href="#"
                className="text-slate-500 hover:text-slate-400 text-sm transition-colors"
              >
                Política de Privacidade
              </a>
              <a
                href="#"
                className="text-slate-500 hover:text-slate-400 text-sm transition-colors"
              >
                Termos de Uso
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
